import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=536b07ee&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=js&"
export * from "./inventory.vue?vue&type=script&lang=js&"
import style0 from "./inventory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./inventory.vue?vue&type=style&index=1&id=536b07ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b07ee",
  null
  
)

export default component.exports